// actions.js
import * as actionTypes from "./actionsTypes";

export const setValueTypesPublipostages = (value) => ({
  type: actionTypes.SET_VALUE_TYPES_PUBLIPOSTAGES,
  payload: value,
});

export const setCategorieTypesPublipostages = (categorie) => ({
  type: actionTypes.SET_CATEGORIE_TYPES_PUBLIPOSTAGES,
  payload: categorie,
});

export const setCurrentPageTypesPublipostages = (page) => ({
  type: actionTypes.SET_CURRENT_PAGE_TYPES_PUBLIPOSTAGES,
  payload: page,
});

export const setOrderTypesPublipostages = (order) => ({
  type: actionTypes.SET_ORDER_TYPES_PUBLIPOSTAGES,
  payload: order,
});

export const setSortFieldTypesPublipostages = (field) => ({
  type: actionTypes.SET_SORT_FIELD_TYPES_PUBLIPOSTAGES,
  payload: field,
});

export const setAccesInvestisseurTypesPublipostages = (value) => ({
  type: actionTypes.SET_ACCES_INVESTISSEUR_TYPES_PUBLIPOSTAGES,
  payload: value,
});

export const setAccesCgpTypesPublipostages = (value) => ({
  type: actionTypes.SET_ACCES_CGP_TYPES_PUBLIPOSTAGES,
  payload: value,
});
